var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("../assets/success.png"),"alt":""}}),_c('p',{staticClass:"no1"},[_vm._v("提交成功！")])])])
}]

export { render, staticRenderFns }